import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { getAcl, getRole, getToken, ListMenu, getFirstAccessibleMenuPath, getMenuAccess } from '../utils/common';
import { LoginButton, LogoutButton } from './component/buttonkeycloak';
import logger from '../utils/logger';

export default function LoadingPage() {
  const navigate = useNavigate();
  const token = getToken();
  const role = getRole();

  useEffect(() => {
    if (sessionStorage.getItem('token') === 'undefined' || sessionStorage.getItem('token') === null) {
      sessionStorage.clear();
      navigate('/login', { replace: true });
      return;
    }

    // Check if user has valid role - stay on loading page instead of redirecting
    if (role === 'norole' || role === 'undefined' || token === 'gada') {
      return;
    }

    setTimeout(async () => {
      let acl = getAcl();

      // Check if ACL is valid
      const isValidAcl = (aclValue) => {
        if (!aclValue) return false;
        if (aclValue === '[]' || aclValue === 'null' || aclValue === 'undefined' || aclValue === '') return false;
        try {
          const parsed = JSON.parse(aclValue);
          return Array.isArray(parsed) && parsed.length > 0;
        } catch {
          return false;
        }
      };

      // Wait for ACL if not available
      if (!isValidAcl(acl)) {
        try {
          await getMenuAccess(true);
          await new Promise((resolve) => setTimeout(resolve, 1000)); // Wait more for storage
          acl = getAcl();

          // Re-check validity after fetch
          if (!isValidAcl(acl)) {
            // Try one more time
            await new Promise((resolve) => setTimeout(resolve, 1000));
            acl = getAcl();
          }
        } catch (error) {
          logger.error('LoadingPage: Failed to fetch permissions:', error);
        }
      }

      // Check if there's a stored redirect path
      const redirectPath = sessionStorage.getItem('redirectAfterLogin');
      if (redirectPath && redirectPath !== '/login' && redirectPath !== '/welcome') {
        sessionStorage.removeItem('redirectAfterLogin');
        navigate(redirectPath, { replace: true });
      } else {
        // Use helper function to get first accessible menu (matches sidebar logic exactly)
        const firstMenuPath = getFirstAccessibleMenuPath(acl);
        navigate(firstMenuPath, { replace: true });
      }
    }, 2000); // Wait 2 seconds for permissions to load
  }, [role, navigate, token]);

  return (
    <>
      <Helmet>
        <title> SMARTSHIELD </title>
      </Helmet>
      <Grid
        xs={12}
        item
        md={6}
        style={{
          backgroundImage: 'url(/assets/Signup.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'absolute',
          height: '100vh',
          zIndex: '1',
        }}
      >
        {''}
        {role === 'norole' || token === 'gada' ? (
          <div className="relative z-100 container mx-auto px-4 h-full">
            <div className="relative flex content-center items-center justify-center h-full">
              <img src="/assets/smartshield.webp" alt="SMARTSHIELD Logo" className="w-100" width="200" height="200" />

              <div className="text-center mb-3">
                 <h1 className="text-center text-5xl font-bold">
  Welcome to{" "}
  <span className="
  bg-gradient-to-r
  from-[#3fbac2]
  via-[#2563eb]
  to-[#1e293b]
  bg-clip-text
  text-transparent
">
  SMARTSHIELD
</span>
</h1>
                <Typography variant="h2" align="center" style={{ color: '#000000', paddingBottom: '30px' }}>
                  You don't have access to SMARTSHIELD
                </Typography>
                <Typography variant="body1" align="center" style={{ color: '#666', paddingBottom: '30px' }}>
                  Please contact the administrator to assign the appropriate role to your account.
                </Typography>
                <div style={{ paddingTop: '30px' }}> {token ? <LogoutButton /> : ''}</div>

                <div className="w-full">
                  <Typography variant="h6" align="center" style={{ color: '#21386d', paddingTop: '30px' }}>
                    {' '}
                    &copy; 2024 ChainSmart - All Rights Reserved
                  </Typography>
                </div>
              </div>
            </div>
            <div style={{ width: '100%' }} className="flex-auto px-4 lg:px-10 py-10 pt-0" />
          </div>
        ) : (
          <div className="relative z-100 container mx-auto px-4 h-full">
            <div className="relative flex content-center items-center justify-center h-full">
              <img src="/assets/smartshield.webp" alt="SMARTSHIELD Logo" className="w-100" width="200" height="200" />

              <div className="text-center mb-3">
                <h1 className="text-center text-5xl font-bold">
  Welcome to{" "}
  <span className="
  bg-gradient-to-r
  from-[#3fbac2]
  via-[#2563eb]
  to-[#1e293b]
  bg-clip-text
  text-transparent
">
  SMARTSHIELD
</span>
</h1>
                <div className="w-full">
                  <Typography variant="h6" align="center" style={{ color: '#21386d', paddingTop: '30px' }}>
                    {' '}
                    &copy; 2024 ChainSmart - All Rights Reserved
                  </Typography>
                  <div style={{ opacity: 0, pointerEvents: 'none' }}>
                    <LoginButton />
                  </div>
                </div>
              </div>
            </div>
            <div style={{ width: '100%' }} className="flex-auto px-4 lg:px-10 py-10 pt-0" />
          </div>
        )}
      </Grid>
    </>
  );
}
